// extracted by mini-css-extract-plugin
module.exports = {"offcanvas":"FilterTabs_offcanvas__2Ekv9","filterButton":"FilterTabs_filterButton__3jFa_","tabContentRow":"FilterTabs_tabContentRow__XLma6"};